var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuzzleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.56672 4.79323H4.49172C4.8461 4.79323 5.13338 4.50595 5.13338 4.15156V3.5099C5.13338 2.80113 5.70795 2.22656 6.41672 2.22656C7.12548 2.22656 7.70005 2.80113 7.70005 3.5099V4.15156C7.70005 4.50595 7.98733 4.79323 8.34172 4.79323H10.2667C10.6211 4.79323 10.9084 5.08051 10.9084 5.4349V7.3599C10.9084 7.71428 11.1957 8.00156 11.55 8.00156H12.1917C12.9005 8.00156 13.475 8.57613 13.475 9.2849C13.475 9.99366 12.9005 10.5682 12.1917 10.5682H11.55C11.1957 10.5682 10.9084 10.8555 10.9084 11.2099V13.1349C10.9084 13.4893 10.6211 13.7766 10.2667 13.7766H8.34172C7.98733 13.7766 7.70005 13.4893 7.70005 13.1349V12.4932C7.70005 11.7845 7.12548 11.2099 6.41672 11.2099C5.70795 11.2099 5.13338 11.7845 5.13338 12.4932V13.1349C5.13338 13.4893 4.8461 13.7766 4.49172 13.7766H2.56672C2.21233 13.7766 1.92505 13.4893 1.92505 13.1349V11.2099C1.92505 10.8555 2.21233 10.5682 2.56672 10.5682H3.20838C3.91715 10.5682 4.49172 9.99366 4.49172 9.2849C4.49172 8.57613 3.91715 8.00156 3.20838 8.00156H2.56672C2.21233 8.00156 1.92505 7.71428 1.92505 7.3599V5.4349C1.92505 5.08051 2.21233 4.79323 2.56672 4.79323",
    stroke: "#8053EA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzleIcon);
export default __webpack_public_path__ + "static/media/puzzle-icon.bd1e3dc7f8a9a748e8d603777e7a9506.svg";
export { ForwardRef as ReactComponent };